import { Controller } from 'react-hook-form'

import { useFormContextContact } from '../_utils'
import ContactFormField from '../ContactFormField'

const RppsId = () => {
    const { control } = useFormContextContact()

    return (
        <Controller
            control={control}
            name="rppsNum"
            render={({ field, fieldState: { error } }) => (
                <ContactFormField
                    variant="input"
                    label="Identifiant RPPS ou ADELI"
                    disabled
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    size="0.5"
                    dataCyScope="ContactField"
                    {...field}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    value={field.value ?? ''}
                    placeholder="Identifiant RPPS ou ADELI"
                />
            )}
        />
    )
}

export default RppsId
